import { Empty } from 'zhs-components';
import CommonTitle from './CommonTitle.vue';
export default {
  props: {
    menu: Object
  },
  components: {
    Empty,
    CommonTitle
  },

  created() {
    // this.getNewsList();
    this.getNewsClassifyList();
  },

  watch: {
    classifyId: {
      handler(val) {
        this.getNewsList();
      },

      immediate: true
    }
  },

  data() {
    return {
      newsList: [],
      bigNewsList: [],
      smallNewsList: [],
      mainRecommendNews: null,
      classifyList: [],
      classifyId: '',
      hiddenMoreClass: true
    };
  },

  methods: {
    // 增加观看次数
    async addViewCount(id) {
      const res = await this.$http.addViewCount({
        id
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      console.log('count', res);
    },

    handleLookDetail(item) {
      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?type=1&id=${item.id}&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`;
      } else {
        this.addViewCount(item.id);
        window.open(item.news_url);
      }
    },

    async getNewsList() {
      this.mainRecommendNews = null;
      let res = (await this.$http.getHomeNews({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.classifyId
      })) || []; // res = [
      //   {
      //     id: '1864577302831173632',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/bf555abcbecc4654be84b44fd736120a.jpg',
      //     news_name: '天气预报',
      //     publish_time: '2024/12/05 00:00:00',
      //     context:
      //       '<p>网络开小差了,请稍后再试 12月4日是第十一个国家<em>宪法</em>日。宪法是治国安邦的总章程,是我们党治国理政的根本<em>法律</em>依...学习新语｜&ldquo;<em>对宪法法律始终保持敬畏之心</em>&rdquo;12月4日是第十一个国家宪法日。宪法是治国安邦的总章程，是我们党治国理政的根本法律依据，是国家政治和社会生活的最高法律规范。</p>',
      //     classify_id: '1540253481582071808',
      //     news_type: 1,
      //     news_url: null,
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/bf555abcbecc4654be84b44fd736120a.jpg'
      //   },
      //   {
      //     id: '1640171902435725312',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/325498417b954e55a507cd2153643071.jpg',
      //     news_name: '需要跳转外部链接',
      //     publish_time: '2023/03/27 00:00:00',
      //     context:
      //       '<p><a href="#/1540202570813935616/1540202570813935616/news-add?menu_id=1540202570813935616边防官" target="_blank" rel="noopener">http://shiepedu.zhihuishu.com/admin/#/1540202570813935616/1540202570813935616/news-add?menu_id=1540202570813935616边防官</a>兵</p>',
      //     classify_id: '1541968810771353600',
      //     news_type: 2,
      //     news_url:
      //       'http://shiepedu.zhihuishu.com/admin/#/1540202570813935616/1540202570813935616/news-add?menu_id=1540202570813935616',
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/325498417b954e55a507cd2153643071.jpg'
      //   },
      //   {
      //     id: '1640171513346920448',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/2ccf874b7c694ca99e6758c97411a975.jpg',
      //     news_name: '站内阅读',
      //     publish_time: '2023/03/27 00:00:00',
      //     context: '<p>vdfg</p>',
      //     classify_id: '1541968786914152448',
      //     news_type: 1,
      //     news_url: null,
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/2ccf874b7c694ca99e6758c97411a975.jpg'
      //   },
      //   {
      //     id: '1630468443528630272',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/79d29bce1b7a491ea6546e4cdc1b3fe7.jpg',
      //     news_name: '哈哈哈哈11',
      //     publish_time: '2023/02/28 15:41:34',
      //     context: '<p>ffsdfsfsfsfsfsfsdf</p>',
      //     classify_id: '1547775486292267008',
      //     news_type: 2,
      //     news_url: 'http://192.168.100.81:3000/project/116/interface/api',
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/79d29bce1b7a491ea6546e4cdc1b3fe7.jpg'
      //   },
      //   {
      //     id: '1640171902435725312',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/325498417b954e55a507cd2153643071.jpg',
      //     news_name: '需要跳转外部链接',
      //     publish_time: '2023/03/27 00:00:00',
      //     context:
      //       '<p><a href="#/1540202570813935616/1540202570813935616/news-add?menu_id=1540202570813935616边防官" target="_blank" rel="noopener">http://shiepedu.zhihuishu.com/admin/#/1540202570813935616/1540202570813935616/news-add?menu_id=1540202570813935616边防官</a>兵</p>',
      //     classify_id: '1541968810771353600',
      //     news_type: 2,
      //     news_url:
      //       'http://shiepedu.zhihuishu.com/admin/#/1540202570813935616/1540202570813935616/news-add?menu_id=1540202570813935616',
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/325498417b954e55a507cd2153643071.jpg'
      //   },
      //   {
      //     id: '1640171513346920448',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/2ccf874b7c694ca99e6758c97411a975.jpg',
      //     news_name: '站内阅读',
      //     publish_time: '2023/03/27 00:00:00',
      //     context: '<p>vdfg</p>',
      //     classify_id: '1541968786914152448',
      //     news_type: 1,
      //     news_url: null,
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/2ccf874b7c694ca99e6758c97411a975.jpg'
      //   },
      //   {
      //     id: '1630468443528630272',
      //     news_cover_url:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/79d29bce1b7a491ea6546e4cdc1b3fe7.jpg',
      //     news_name: '哈哈哈哈11',
      //     publish_time: '2023/02/28 15:41:34',
      //     context: '<p>ffsdfsfsfsfsfsfsdf</p>',
      //     classify_id: '1547775486292267008',
      //     news_type: 2,
      //     news_url: 'http://192.168.100.81:3000/project/116/interface/api',
      //     news_cover_url2:
      //       'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/79d29bce1b7a491ea6546e4cdc1b3fe7.jpg'
      //   }
      // ]

      this.bigNewsList = res.slice(0, 2);
      this.smallNewsList = res.slice(2, 7);
    },

    async getNewsClassifyList() {
      const res = await this.$http.getNewsClassify({
        menu_id: this.menu.menu_id
      });
      this.classifyList = res;
      this.classifyList.unshift({
        name: '全部',
        id: ''
      }); // if (res && res.length) {
      //   this.classifyId = res[0].id
      // }
    },

    searchCourseList(id) {
      console.log(id);
      this.classifyId = id; // this.getNewsList();
    }

  }
};